module.exports = __webpack_public_path__ + "static/media/quo.39902c94.png";